module.exports = __webpack_public_path__ + "assets/img/hj2.f2e055bb.png";